export var Mutations;
(function (Mutations) {
    Mutations["SET_MODAL_LOADING"] = "setModalLoading";
})(Mutations || (Mutations = {}));
